const initForm = appSettings => {
  /* eslint-disable func-names */
  window.smeProductResultText =
    '<p class="form-result-text">Благодарим за регистрацию!<br />На Вашу электронную почту отправлено письмо, перейдите по&nbsp;ссылке из&nbsp;письма, чтобы&nbsp;завершить регистрацию.</p>';

  window.smeProduct = 'ACCOUNTING';

  const NativeLoader = window['@sme/sme-front-native-loader'].default;

  new NativeLoader({
    applicationName: 'site-lead-form',
    serviceBaseUrl: appSettings.SME_FORM_URL,
    manifestUrl: `${appSettings.SME_FORM_URL}/manifest.json`
  })
    .asyncAppendWith({
      selectors: '#smeAccountLeadForm',
      publicPath: '/site-lead-form/',
      appSettings: {
        SME_SERVICE_BASE_URL: appSettings.SME_API_URL,
        recaptchaPublicKey: appSettings.recaptchaPublicKey
      }
    })
    .catch(function(e) {
      console.error(e);
    });
};

fetch('./app-settings.json')
  .then(function(response) {
    return response.json();
  })
  .then(function(appSettings) {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', function() {
        initForm(appSettings);
      });
    } else {
      initForm(appSettings);
    }
  });
